import * as React from "react"

import { cn } from "@/lib/utils"

const Card = ({
  ref,
  className,
  disabled,
  ...props
}: React.ComponentPropsWithRef<"div"> & {
  disabled?: boolean
}) => (
  <div
    ref={ref}
    {...props}
    className={cn(
      `rounded-lg border bg-card text-card-foreground shadow-sm`,
      className,
      {
        "opacity-50 cursor-not-allowed hover:border-gray-200": disabled,
      }
    )}
  />
)
Card.displayName = `Card`

const CardHeader = ({
  ref,
  className,
  ...props
}: React.ComponentPropsWithRef<"div">) => (
  <div
    ref={ref}
    className={cn(`flex flex-col space-y-1.5 p-6`, className)}
    {...props}
  />
)
CardHeader.displayName = `CardHeader`

const CardTitle = ({
  ref,
  className,
  children,
  ...props
}: React.ComponentPropsWithRef<"h3">) => (
  <h3
    ref={ref}
    className={cn(`text-xl font-medium leading-none tracking-tight`, className)}
    {...props}
  >
    {children}
  </h3>
)
CardTitle.displayName = `CardTitle`

const CardDescription = ({
  ref,
  className,
  ...props
}: React.ComponentPropsWithRef<"p">) => (
  <p
    ref={ref}
    className={cn(`text-sm text-muted-foreground`, className)}
    {...props}
  />
)
CardDescription.displayName = `CardDescription`

const CardContent = ({
  ref,
  className,
  ...props
}: React.ComponentPropsWithRef<"div">) => (
  <div ref={ref} className={cn(`p-6 pt-0`, className)} {...props} />
)
CardContent.displayName = `CardContent`

const CardFooter = ({
  ref,
  className,
  ...props
}: React.ComponentPropsWithRef<"div">) => (
  <div
    ref={ref}
    className={cn(`flex items-center p-6 pt-0`, className)}
    {...props}
  />
)
CardFooter.displayName = `CardFooter`

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
